import Axios from 'axios'
import url from '../../config/url'

export const DESIGNERS = 'DESIGNERS'
export const DESIGNER_PORTFOLIO = 'DESIGNER_PORTFOLIO'

export const setDesigners = payload => ({
  type: DESIGNERS,
  payload,
})
export const setDesignerPortfolio = payload => ({
  type: DESIGNER_PORTFOLIO,
  payload,
})
export const fetchDesignerPortfolio = id => {
  return dispatch => {
    Axios({
      method: 'get',
      hedaers: {
        'Access-Control-Allow-Origin': '*',
      },
      url: url + `api/admin/portfolio?designer_id=${id}`,
    }).then(({ status, data }) => {
      if (status === 200) {
        dispatch(
          setDesignerPortfolio({
            id,
            data,
          })
        )
      }
    })
  }
}

export const fetchDesigners = () => {
  return dispatch => {
    Axios({
      method: 'get',
      hedaers: {
        'Access-Control-Allow-Origin': '*',
      },
      url: url + 'api/admin/designer',
    }).then(({ status, data = [] }) => {
      if (status === 200) {
        const designersList = data.map(({ portfolio, ...item }) => {
          try {
            const arr = JSON.parse(portfolio)
            if (!Array.isArray(arr)) throw new Error()
            return { ...item, portfolio: arr }
          } catch (error) {
            return { ...item, portfolio: [] }
          }
        })
        dispatch(setDesigners(designersList))

        designersList.forEach(async ({ id: designerId }) => {
          const { status, data: designerPortfolio } = await Axios({
            method: 'get',
            hedaers: {
              'Access-Control-Allow-Origin': '*',
            },
            url: url + `api/admin/portfolio?designer_id=${designerId}`,
          })
          if (status === 200) {
            designersList.find(
              ({ id }) => id === designerId
            ).portfolio = designerPortfolio
            dispatch(setDesigners(designersList))
          }
        })
      }
    })
  }
}
